import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from 'react-redux';
import * as ChannelActions from '../../../middleware/Store/Actions/ChannelActions';

import * as Utils from "../../Utils/UIUtils";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "ATTACHMENT_CHANNEL_ITEM";

const AttachmentChannelItem = (props) => {
    const dispatch = useDispatch();

    const onDownloadFile = (event, fileId) => {
        event.preventDefault();
        LogService.info(LOG_TAG, "DownLoad File...with id", fileId);

        let callback = function (url) {
            LogService.trace(LOG_TAG, "onDownloadFile", "Get URL to downLoad succefully " + url);
            window.location = url;
        };

        dispatch(ChannelActions.getUrlToDownloadFile(fileId, callback, this));
    }

    function getFileName(id){
        let list = props.attachments;
        if (!list) return "";

        for (const item of list) {
            if (item.id === id) {
              return item.fileName
            }
        }
    }

    function getExtentionFile(id){
        let list = props.attachments;
        if (!list) return "";

        for (const item of list) {
            if (item.id === id) {
              return item.extension
            }
        }
    }

    const getIcon = (id) => {
        let val = getExtentionFile(id);
        return Utils.getFileTypeIcon(val);
    }
    
    function Attachment(props) {
        return (<div className="form-control mb-1" onClick={props.onClick} style={{cursor:"pointer"}}>
                <FontAwesomeIcon icon={props.icon} className="mr-2" />{props.fileName}
                <FontAwesomeIcon icon={faDownload} className="float-right mt-1"/>
            </div>);
    }

    let attachments = null;
    if(props.entry && props.entry.attachments) {
        if (props.entry.attachments.length > 0) {
            attachments = props.entry.attachments.map((attachment, index) => (
                <Attachment key={`attachment-${index}`}
                    icon={getIcon(attachment.id)}
                    fileName={getFileName(attachment.id)}
                    onClick={(e, id) => onDownloadFile(e, attachment.id)}
                />
            ));
        } else {
            attachments = <Attachment key="attachment-0" 
                    icon={getIcon(props.entry.attachments.id)} 
                    fileName={getFileName(props.entry.attachments.id)}
                    onClick={(e, id) => onDownloadFile(e, props.entry.attachments.id)} 
                />;
        }
        
        return (<div className="pb-2 pl-2 pr-2">{attachments}</div>);
    }

    return "";
}

AttachmentChannelItem.propTypes = {
    entry: PropTypes.object,
    attachments: PropTypes.array
}

export default AttachmentChannelItem;